<template>
    <div v-if="isCompleted && !showTrackerEvenIfCompleted">
        <WebpImage
            class="bonusomat-progress bonusomat-progress--img"
            src="/frontend/web/img/casino/bonusomat/progress-done.svg"
            alt=""
        />
    </div>
    <div
        class="bonusomat-progress-wrap"
        :class="{ 'bonusomat-progress__contains-percentage': showPercentageNumber }"
        v-else-if="isVisible"
    >
        <svg class="bonusomat-progress bonusomat-progress--rotate" :style="`--progress-value: ${progressValue}`">
            <circle class="bonusomat-progress__track"></circle>
            <circle class="bonusomat-progress__value" stroke="url(#value-gradient)"></circle>
            <defs>
                <linearGradient id="value-gradient">
                    <stop stop-color="#76D911" />
                    <stop offset="1" stop-color="#54C00C" />
                </linearGradient>
            </defs>
        </svg>
        <div v-if="showPercentageNumber" class="bonusomat-progress__percentage">
            {{ progressLabel }}
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";

import WebpImage from "@sazka/design-system/src/image/webp-image.vue";

const props = defineProps<{
    progress?: number;
    isCompleted?: boolean;
    showPercentageNumber?: boolean;
    alwaysVisible?: boolean;
    showTrackerEvenIfCompleted?: boolean;
}>();

const isVisible = computed(() => {
    return (props.progress > 0 && props.progress < 100) || props.showPercentageNumber || props.alwaysVisible;
});

const progressLabel = computed(() => {
    if (isNaN(props.progress)) {
        return "";
    }

    return `${props.progress > 99 ? Math.floor(props.progress) : Math.round(props.progress)} %`;
});

const progressValue = computed(() => {
    if (isNaN(props.progress)) {
        return 1;
    }

    const min = 0;
    const max = 1;
    const value = 1 - props.progress / 100;

    return Math.min(Math.max(value, min), max);
});
</script>
